import ApiService from '../../../core/services/ApiService';

export interface FixedAsset {
  id: string;
  assetName: string;
  assetClass: string;
  depreciationMethod: string;
  inServiceDate: string;
  originalCost: number;
  accumulatedDepreciation: number;
  taxBasis: number;
  isDisposed: boolean;
  tags: string[];
}

export interface FixedAssetSummary {
  totalOriginalCost: number;
  accumulatedDepreciation: number;
  adjustedTaxBasis: number;
  activeCount: number;
  disposedCount: number;
  assets: FixedAsset[];
}

class FixedAssetService extends ApiService {
  async getAssets(partnershipId: string, taxYear: string): Promise<FixedAssetSummary> {
    return this.makeRequest<FixedAssetSummary>(
      `/api/fixed-assets?partnershipId=${partnershipId}&taxYear=${taxYear}`,
      { extractData: true },
    );
  }

  async createAsset(
    data: Partial<FixedAsset> & { partnershipId: string; taxYear: string },
  ): Promise<FixedAsset> {
    return this.makeRequest<FixedAsset>(
      '/api/fixed-assets',
      { method: 'post', data: data as unknown as Record<string, unknown>, extractData: true },
    );
  }

  async updateAsset(id: string, data: Partial<FixedAsset>): Promise<FixedAsset> {
    return this.makeRequest<FixedAsset>(
      `/api/fixed-assets/${id}`,
      { method: 'put', data: data as unknown as Record<string, unknown>, extractData: true },
    );
  }
}

export const fixedAssetService = new FixedAssetService();
